import CarProfile from '@phosphor-icons/react/CarProfile'
import Factory from '@phosphor-icons/react/Factory'
import ListChecks from '@phosphor-icons/react/ListChecks'
import Truck from '@phosphor-icons/react/Truck'
import Warehouse from '@phosphor-icons/react/Warehouse'
import PackageIcon from '@phosphor-icons/react/Package'
import CheckRounded from '@phosphor-icons/react/CheckCircle'
import ErrorOutlineRounded from '@phosphor-icons/react/WarningCircle'

import WarningSVG from '../../assets/WarningSVG'
import i18n from '../../i18n'
import { PackageEventOperations } from '@consumer/graphql'
import { packageEvents } from '@consumer/shared'

export const mapEventToLabelIcon = (
  event: PackageEventOperations,
  clientDisplayName: string,
  isLatest?: boolean
): { label: string; icon?: React.ReactNode } => {
  const iconProps = { size: 24, color: isLatest ? '#FFFFFF' : '#21211f' }
  switch (event) {
    case packageEvents.CREATED:
      return {
        label: i18n.t('common:STATUS.ORDER_INFO_RECEIVED'),
        icon: <ListChecks {...iconProps} />,
      }
    case packageEvents.PACKAGE_DELAYED:
      return {
        label: i18n.t('common:STATUS.PACKAGE_DELAYED'),
        icon: <WarningSVG />,
      }
    case packageEvents.PICKED_UP_FROM_CLIENT:
      return {
        label: i18n.t('common:STATUS.DEPARTED_CLIENT_FACILITY', { clientDisplayName }),
        icon: <Factory {...iconProps} />,
      }
    case packageEvents.DROPPED_OFF_AT_VEHO:
      return {
        label: i18n.t('common:STATUS.ARRIVED_AT_VEHO_FACILITY'),
        icon: <Warehouse {...iconProps} />,
      }
    case packageEvents.PACKAGE_DEPARTED_FROM_FACILITY:
      return {
        label: i18n.t('common:STATUS.IN_TRANSIT'),
        icon: <Truck {...iconProps} />,
      }
    case packageEvents.PACKAGE_ARRIVED_AT_FACILITY:
      return {
        label: i18n.t('common:STATUS.AT_VEHO_FACILITY'),
        icon: <Warehouse {...iconProps} />,
      }
    case packageEvents.PICKED_UP_FROM_VEHO:
      return {
        label: i18n.t('common:STATUS.OUT_FOR_DELIVERY'),
        icon: <CarProfile {...iconProps} />,
      }
    case packageEvents.DELIVERED:
      return {
        label: i18n.t('common:STATUS.DELIVERED'),
        icon: <PackageIcon {...iconProps} weight={isLatest ? 'bold' : 'regular'} />,
      }
    case packageEvents.PACKAGE_LOADED_ONTO_FIRST_MILE_TRANSIT:
      return {
        label: 'Package is in transit to a Veho Facility',
        icon: <Truck {...iconProps} />,
      }
    case packageEvents.PACKAGE_HAD_DELIVERY_ISSUE:
      return {
        label: i18n.t('common:STATUS.DELIVERY_ISSUE'),
        icon: <WarningSVG />,
      }
    case packageEvents.MISDELIVERED:
    case packageEvents.DISCARDED:
    case packageEvents.NOT_RECEIVED_FROM_CLIENT:
    case packageEvents.RETURNED_TO_CLIENT:
    case packageEvents.CANCELLED:
      return {
        label: i18n.t('common:STATUS.ISSUE_WITH_ORDER'),
        icon: <ErrorOutlineRounded {...iconProps} fill="#972626" />,
      }
    case packageEvents.RETURNED_TO_VEHO:
      return {
        label: 'Returned to Veho facility',
        icon: <ErrorOutlineRounded {...iconProps} fill="#972626" />,
      }
    case packageEvents.WRONG_FACILITY_BY_CLIENT:
    case packageEvents.WRONG_FACILITY_BY_VEHO:
      return {
        label: 'Transit error',
        icon: <WarningSVG />,
      }
    default:
      return {
        label: 'Update received',
        icon: <CheckRounded />,
      }
  }
}
